<div class="modal-header">
  <div>
    <h4 class="modal-title">
      <span class="fw-bold">{{observationSummary?.itemName}} ({{observationSummary?.schoolYear}}) -
        Evidence</span>
    </h4>

    <div class="text-start">
      <span><b>Evaluator</b>: {{observationSummary?.evalUser?.displayName}} </span><span class="ps-5"><b>Date:</b>
        {{observationSummary?.dateCreated | date:
        "M/d/yyyy"}}</span>
    </div>
  </div>
  <button type="button" class="btn btn-info cancel" (click)="activeModal.dismiss('cancel')"><i
      class="fas fa-times"></i></button>
</div>

<div class="modal-body">
  <div class="tab">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs nav">
      <li [ngbNavItem]="1">
        <a ngbNavLink>Comment</a>
        <ng-template ngbNavContent>
          <app-observation-comment-form
            [observationSummary]="observationSummary"
            [comment]="comment"
            [observationType]="observationType"
            [observationId]="observationId"
            [defaultLookupValue]="defaultLookupValue"
            [hideLookup]="hideLookup"
            (onClose)="onClose()"
          ></app-observation-comment-form>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink>Attachments</a>
        <ng-template ngbNavContent>
          <p>Attachments</p>
        </ng-template>
      </li>
    </ul>

    <div [ngbNavOutlet]="nav" class=""></div>

  </div>
</div>